import {
	TRAVEL_RULE_POI_ALLOWED_STATUSES,
	useGetRequirementStateByIdentifierQuery
} from '@capsicum/features/regulations/shared';

export const useVerifyModalRequirements = () => {
	const { data: poiRequirementStatus, isLoading: isLoadingPOI } = useGetRequirementStateByIdentifierQuery({
		requirementIdentifier: 'proof_of_id'
	});
	const { data: poaRequirementStatus, isLoading: isLoadingPOA } = useGetRequirementStateByIdentifierQuery({
		requirementIdentifier: 'proof_of_address'
	});

	const isSumsubDoneOrWaiting =
		poiRequirementStatus?.status && TRAVEL_RULE_POI_ALLOWED_STATUSES.includes(poiRequirementStatus.status);

	const isTravelRuleBlockedBySumsub = poiRequirementStatus?.status === 'completed_deny';

	return {
		isRequirementsLoading: isLoadingPOI || isLoadingPOA,
		isSumsubDoneOrWaiting,
		isTravelRuleBlockedBySumsub,
		poaRequirementStatus,
		poiRequirementStatus
	};
};
